module.exports = __webpack_public_path__ + "img/bank2-bg.3eb248cd.png";